export { default as NewsPage } from "./NewsPage";
